import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { from, take, tap } from 'rxjs';
import { Colaborador } from 'src/app/models/colaborador';
import { EscalaPeriodo, EscalaPeriodoColaborador, SetorColaboradores } from 'src/app/models/escala';
import { CHANGE_REQUEST_TYPE, CHANGE_REQUEST_TYPE_NAME, RequestChange } from 'src/app/models/request-change';
import { SolicitacaoTroca, TipoSolicitacao } from 'src/app/models/solicitacao-troca';
import { ScaleInUseService } from 'src/app/services/scale-in-use.service';

@Component({
  selector: 'scale-change-request-card',
  templateUrl: './scale-change-request-card.component.html',
  styleUrls: ['./scale-change-request-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScaleChangeRequestCardComponent  implements OnInit {

  @Input() requestData!: SolicitacaoTroca;

  tipoSolicitacao = TipoSolicitacao;

  types = CHANGE_REQUEST_TYPE_NAME;

  fromColaborador!: EscalaPeriodoColaborador | undefined;
  toColaborador!: EscalaPeriodoColaborador | undefined;

  @Input() showFooter: boolean = true;
  @Input() itemColor: string = '#f5f5f5';


  @Output() approve: EventEmitter<void> = new EventEmitter<void>();
  @Output() reprove: EventEmitter<void> = new EventEmitter<void>();


  constructor(
    private scaleInUse: ScaleInUseService
  ) { }

  ngOnInit() {
    this.scaleInUse.getObservable().pipe(
      take(1),
      tap((response) => {
        if(!response) return;
        const origem = this.requestData.itemOrigem!;
        const setorFrom = response.setorColaboradores.find((setor) => setor.setor.id == origem.setor.id)
        if(setorFrom) this.fromColaborador = this.findColaborador(setorFrom!, origem.escalaPeriodoColaboradorId!);

        switch(this.requestData.tipoSolicitacao) {
          case TipoSolicitacao.TROCA:
            this.loadTroca(response);
            break;
          case TipoSolicitacao.PASSAGEM:
            this.loadPasse(response);
            break;
          case TipoSolicitacao.REMANEJAMENTO:
        }
      })
    ).subscribe()
  }

  findColaborador = (array: SetorColaboradores, idColaborador: number) => array.colaboradores.find((colaborador) => colaborador.escalaPeriodoColaboradorId == idColaborador);

  loadTroca(response: EscalaPeriodo) {
    const destino = this.requestData.itensDestinoTroca[0].itemColaborador;
    const setorTo = response.setorColaboradores.find((setor) => setor.setor.id == destino.setor.id)
    if((setorTo) == undefined) return;


    this.toColaborador = this.findColaborador(setorTo!, destino.escalaPeriodoColaboradorId!);
  }

  loadPasse(response: EscalaPeriodo) {
    const passagem = this.requestData.colaboradoresDestinoPasse[0];
    const setorTo = response.setorColaboradores.find((setor) => setor.setor.id == this.requestData.itemOrigem!.setor.id)
    console.log(setorTo)
    if(!setorTo) return;
    this.toColaborador = this.findColaborador(setorTo, passagem.escalaPeriodoColaborador.escalaPeriodoColaboradorId);
    console.log(this.toColaborador, passagem, passagem.escalaPeriodoColaborador.escalaPeriodoColaboradorId)
  }

}
